<script>

import CheckBox from "@/components/Common/Inputs/CheckBox.vue";
import MainButton from "@/components/Common/Buttons/MainButton.vue";

export default {
  components: {
    MainButton,
    CheckBox
  },
  props: {
    offices: {
      type: Array
    },
  },
  data() {
    return {
      selectedFilters: []
    }
  },
  methods: {
    handleChecked(e) {
      const index = this.selectedFilters.indexOf(e.value);
      if (index !== -1) {
        this.selectedFilters.splice(index, 1);
      }

      if (e.checked) {
        this.selectedFilters.push(e.value)
      }
    },
    async filter() {
      await this.$store.dispatch("utils/toggleOfficesModal", false);
      this.$emit('update:modelValue', this.selectedFilters);
    }
  }
}
</script>

<template>
  <div class="submenu-wrapper">
    <label class="d-flex submenu-items d-flex" v-for="(office, index) in offices" :key="index">
      <CheckBox :checked="selectedFilters.includes(office.id)" :value="office.id" @onChecked="handleChecked"/>
      <span class="ms-3"> {{ office.content.title }}</span>
    </label>
  </div>
  <div class="d-flex justify-content-center mt-4" @click="filter()">
    <MainButton :button-text="$t('apply-filters-button')"
                :size="'medium'"
                :theme="'solid-blue'"
                class="col-md-6 col-12"
                @click="filter()"/>
  </div>
</template>

<style lang="scss" scoped>
.submenu-wrapper {
  margin-top: 25px;
  max-height: 525px;
  overflow-y: auto;

  .submenu-items {
    cursor: pointer;
    padding: 10px 0;
    font-size: $paragraph-1;
    color: $color-brown;
  }
}

.submenu-wrapper::-webkit-scrollbar {
  width: 8px; /* Width of the scrollbar */
  padding: 5px;
}

.submenu-wrapper::-webkit-scrollbar-thumb {
  background: #CEA997;
  border-radius: 6px; /* Roundness of the handle */


}

.submenu-wrapper::-webkit-scrollbar-track {
  background: #FDF5F1; /* Color of the scrollbar track */
  border-radius: 6px; /* Roundness of the track */
  margin: 5px;
}

@media screen and (max-width: 380px) and (max-height: 680px) {
  .submenu-wrapper {
    max-height: 400px;
  }
}

@media screen and (max-width: 360px) and (max-height: 740px) {
  .submenu-wrapper {
    max-height: 425px;
  }
}

@media screen and (min-width: 400px) and (min-height: 900px) {
  .submenu-wrapper {
    max-height: 600px;
  }
}


@media screen and (min-width: 1060px) and (max-width: 1400px) {
  .submenu-wrapper {
    max-height: 250px;
  }
}

@media screen and (min-width: 1410px) {

  .submenu-wrapper {
    max-height: 400px;
  }

}
</style>